export const PAYMENT_STATUS_PSE = {
  'OK': {
    value: 1,
    label: 'Transacción aprobada',
  },
  'NOT_AUTHORIZED': {
    value: 2,
    label: 'Transacción rechazada',
  },
  'PENDING': {
    value: 3,
    label: 'Transacción pendiente',
  },
  'FAILED': {
    value: 4,
    label: 'Transacción fallida',
  },
  'FAILED_FINISH': {
    value: 4,
    label: 'Transición Finalizada',
  },
};
